import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'

export const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: 450px) {
    width: 45px;
    height: 45px;
  }
`

export const Title = styled.div`
  text-transform: uppercase;
  color: ${Theme.colors.semidark_grey};
  transform: scale(1, 1.3) !important;
  letter-spacing: 0.03em;
  font-stretch: condensed;
`

export const MainIcon = styled(Icon)`
  width: 55px;
  height: 55px;

  @media (max-width: 450px) {
    width: 40px;
    height: 40px;
  }
`

export const CommonWrapper = styled.div`
  ${Mixin.responsive('padding', '10px 0 10px', '10px 15px')}
`
